import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// Convierte cada hoja (.contract-page) en una página PDF idéntica a la vista previa.
export const pdfName = (filename) =>
  `${(filename || "contrato").replace(/[^\w\-áéíóúñÁÉÍÓÚÑ ]+/g, "").trim() || "contrato"}.pdf`;

export const buildContractPdf = async (pages) => {
  const pdf = new jsPDF({ unit: "pt", format: "a4", orientation: "portrait" });
  const W = pdf.internal.pageSize.getWidth();
  const H = pdf.internal.pageSize.getHeight();
  const list = pages.filter(Boolean);
  for (let i = 0; i < list.length; i++) {
    const canvas = await html2canvas(list[i], { scale: 2, backgroundColor: "#ffffff", useCORS: true, logging: false });
    if (i > 0) pdf.addPage();
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, W, H);
  }
  return pdf;
};

export const exportContractPdf = async (pages, filename) => (await buildContractPdf(pages)).save(pdfName(filename));
